import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import styled from "styled-components";

const GroupActionsWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0.5rem 1rem;
    box-sizing: border-box;
`;

const ButtonPanel = styled.div`
    display: flex;
    width: 100%;
    max-width: 400px;
    border-radius: 7px;
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f7f7f7;
`;

const IconButton = styled.button`
    all: unset;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 0;
    cursor: pointer;
    background-color: transparent;

    &:not(:last-child) {
        border-right: 1px solid #ccc;
    }

    &:hover {
        background-color: #eaeaea;
    }

    i {
        font-size: 1.25rem;
        color: #333;
    }
`;

/**
 * Action bar with Add Group, Publish All, and Download Floorspace buttons.
 *
 * @param root0 - The component props.
 * @param root0.onAdd - Callback to add a new group.
 * @param root0.onPublishAll - Callback to publish all groups.
 * @param root0.onDownloadFloorspaceFile - Callback to download the floorspace file.
 * @param root0.floorspaceFileUrl - The URL for downloading the floorspace file.
 * @returns The rendered group actions bar.
 */
const GroupActions = ({
    onAdd,
    onPublishAll,
    onDownloadFloorspaceFile,
    floorspaceFileUrl,
}) => (
    <GroupActionsWrapper>
        <ButtonPanel>
            <IconButton
                data-tooltip-id="group-actions-tooltip"
                data-tooltip-content="Add Group"
                onClick={onAdd}
            >
                <i className="fa fa-plus" />
            </IconButton>
            <IconButton
                data-tooltip-id="group-actions-tooltip"
                data-tooltip-content="Publish All"
                onClick={onPublishAll}
            >
                <i className="fa fa-upload" />
            </IconButton>
            {floorspaceFileUrl && (
                <IconButton
                    data-tooltip-id="group-actions-tooltip"
                    data-tooltip-content="Download Floorspace File"
                    onClick={onDownloadFloorspaceFile}
                >
                    <i className="fa fa-download" />
                </IconButton>
            )}
        </ButtonPanel>
        <Tooltip id="group-actions-tooltip" place="top" />
    </GroupActionsWrapper>
);

GroupActions.propTypes = {
    onAdd: PropTypes.func.isRequired,
    onPublishAll: PropTypes.func.isRequired,
    onDownloadFloorspaceFile: PropTypes.func.isRequired,
    floorspaceFileUrl: PropTypes.string,
};

export default GroupActions;
